<template>
  <HeaderHome v-if="showHeader" />
  <WidgetHome v-if="$route.path === '/'" />
  <CookiesHome v-if="$route.path === '/' && flagCookies" />

  <main class="site-main" :class="{ 'with-header': showHeader }">
    <router-view />
  </main>

  <DemandeHome v-if="showDemandeHome" />

  <a
    v-if="showWhatsAppButton"
    class="whatsapp-float"
    :href="whatsappLink"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Contacter GTHCONSULT sur WhatsApp"
  >
    <span class="whatsapp-icon" aria-hidden="true">
      <svg viewBox="0 0 32 32" focusable="false">
        <path d="M16.02 4.2A11.72 11.72 0 0 0 6.03 22.07L4.7 27.3l5.36-1.28A11.72 11.72 0 1 0 16.02 4.2Zm0 2.16a9.56 9.56 0 0 1 8.1 14.65 9.55 9.55 0 0 1-12.75 3.1l-.38-.23-3.16.75.78-3.08-.25-.4a9.56 9.56 0 0 1 7.66-14.79Zm-3.54 4.52c-.23 0-.6.08-.92.44-.31.36-1.2 1.18-1.2 2.88 0 1.7 1.24 3.34 1.41 3.57.17.23 2.4 3.84 5.94 5.23 2.94 1.16 3.54.93 4.18.87.64-.06 2.06-.84 2.35-1.65.29-.81.29-1.5.2-1.65-.09-.15-.32-.23-.67-.4-.35-.17-2.06-1.02-2.38-1.13-.32-.12-.55-.17-.78.17-.23.35-.9 1.13-1.1 1.36-.2.23-.41.26-.76.09-.35-.17-1.47-.54-2.8-1.72-1.03-.92-1.73-2.05-1.94-2.4-.2-.35-.02-.54.15-.71.15-.15.35-.41.52-.61.17-.2.23-.35.35-.58.12-.23.06-.43-.03-.61-.09-.17-.78-1.88-1.07-2.58-.28-.67-.57-.58-.78-.59h-.67Z" />
      </svg>
    </span>
    <span>WhatsApp</span>
  </a>

  <footer class="footer_info" v-if="showFooter">
    <div class="footer_top">
      <div class="footer_card">
        <h5 class="footer_title">A propos</h5>
        <p>
          GTHCONSULT est un bureau de controle agree par l'Etat, cree par deux
          ingenieurs pluridisciplinaires. Sa mission est d'accompagner les
          chefs d'etablissements et exploitants dans leurs obligations
          reglementaires ou volontaires: controles techniques, gestion des
          risques professionnels, protection des personnes, des biens et de
          l'environnement.
        </p>
      </div>

      <div class="footer_card">
        <h5 class="footer_title">Contact</h5>
        <ul class="footer_contact">
          <li>Boulevard Mohammed VI, Lot Al Massira, N 187, Appt 5-6, 3eme etage, Mohammedia 28810</li>
          <li>+212 5 23 27 27 74</li>
          <li>+212 5 23 27 29 79</li>
          <li>contact@gthconsult.ma</li>
          <li>service.supports@gthconsult.ma</li>
          <li>9h00 - 17h00 (Lundi - Vendredi)</li>
        </ul>
      </div>

      <div class="footer_card">
        <h5 class="footer_title">Newsletter</h5>
        <p>Recevez nos dernieres actualites et offres :</p>
        <p class="msg_subscriber">{{ msgSubscriber }}</p>
        <div class="newsletter_input">
          <input type="email" v-model="email" placeholder="Votre email" />
          <button @click="sabonner">S'abonner</button>
        </div>
      </div>
    </div>

    <div class="footer_map">
      <iframe
        title="Carte GTHCONSULT Mohammedia"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5779.463841041547!2d-7.370628643336544!3d33.69782057769933!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7b73d256f309f%3A0x3e969925cc12ea26!2sGTHCONSULT!5e0!3m2!1sfr!2sma!4v1684484901048!5m2!1sfr!2sma"
        allowfullscreen
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>

    <div class="footer_bottom">
      <img src="./assets/logo-footer.e772d696.png" alt="Logo GTHCONSULT" />
      <div class="footer_links">
        <button type="button" @click="pageMentionsLegales">Mentions legales</button>
        <button type="button" @click="pagePolitiqueConfidentialite">Politique de confidentialite</button>
        <button type="button" @click="pagePolitiqueCookies">Politique Cookies</button>
        <button type="button" @click="pageFaq">FAQ</button>
        <button type="button" @click="pagePlan">Plan du site</button>
      </div>
      <div class="footer_social">
        <a href="https://www.linkedin.com/company/gthconsult/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn GTHCONSULT">
          <span class="linkedin-icon" aria-hidden="true">in</span>
          <span>LinkedIn</span>
        </a>
      </div>
      <p class="footer_copyright">© {{ currentYear }} GTHCONSULT. Tous droits reserves.</p>
    </div>

    <loading v-model:active="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="true" />
  </footer>
</template>

<script>
import HeaderHome from "@/HeaderHome.vue";
import DemandeHome from "@/DemandeHome.vue";
import WidgetHome from "@/WidgetHome.vue";
import CookiesHome from "@/CookiesHome.vue";
import Subscribers from "@/connection/Subscribers";
import { useCookies } from "vue3-cookies";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  name: "App",
  components: { HeaderHome, DemandeHome, WidgetHome, CookiesHome, Loading },
  data() {
    return {
      isLoading: false,
      flagCookies: true,
      email: null,
      msgSubscriber: null,
    };
  },
  computed: {
    currentPath() {
      return this.$route.path.replace(/\/$/, "") || "/";
    },
    hiddenLayoutRoutes() {
      return [
        "/dashboard",
        "/elearning",
        "/formation",
        "/transfer-dashboard",
        "/transfer-preview",
        "/habilitation-electrique-nfc",
        "/avis",
      ];
    },
    footerHiddenRoutes() {
      return [
        ...this.hiddenLayoutRoutes,
        "/espace-client",
        "/transfer",
        "/demande",
        "/catalogue",
        "/candidature-spontanee",
        "/offre-emploi",
      ];
    },
    showHeader() {
      return !this.hiddenLayoutRoutes.includes(this.currentPath)
        && !this.currentPath.startsWith("/enquete-de-satisfaction");
    },
    showFooter() {
      return !this.footerHiddenRoutes.includes(this.currentPath)
        && !this.currentPath.startsWith("/offre-emplois-details")
        && !this.currentPath.startsWith("/enquete-de-satisfaction");
    },
    showDemandeHome() {
      return this.currentPath !== "/transfer-dashboard"
        && this.currentPath !== "/transfer-preview"
        && this.currentPath !== "/avis";
    },
    showWhatsAppButton() {
      return this.currentPath === "/";
    },
    currentYear() {
      return new Date().getFullYear();
    },
    whatsappLink() {
      return "https://wa.me/212668047801?text=Bonjour%20GTHCONSULT%2C%20je%20souhaite%20avoir%20plus%20d'informations.";
    },
  },
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  mounted() {
    const cookieValue = this.cookies.get("accepteCookies");
    if (cookieValue === "true" || cookieValue === "false") {
      this.flagCookies = false;
    }
    this.injectGlobalJsonLd();
  },
  methods: {
    sabonner() {
      if (!this.email) return;
      this.isLoading = true;
      Subscribers.envoyer(this.email)
        .then((result) => {
          this.msgSubscriber = result.data.msg || "Merci pour votre inscription.";
          this.email = null;
          this.isLoading = false;
        })
        .catch(() => {
          this.msgSubscriber = "Impossible d'envoyer votre demande pour le moment.";
          this.isLoading = false;
        });
    },
    pageMentionsLegales() { this.$router.push({ path: "/mentions-legales-2" }); },
    pagePolitiqueConfidentialite() { this.$router.push({ path: "/politique-de-confidentialite" }); },
    pagePolitiqueCookies() { this.$router.push({ path: "/politique-de-cookies" }); },
    pageFaq() { this.$router.push({ path: "/faq" }); },
    pagePlan() { this.$router.push({ path: "/plan-du-site" }); },
    onCancel() { this.isLoading = false; },
    injectGlobalJsonLd() {
      const scriptId = "gthconsult-global-jsonld";
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();

      const jsonLd = {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Organization",
            "@id": "https://gthconsult.com/#organization",
            "name": "GTHCONSULT",
            "url": "https://gthconsult.com",
            "logo": "https://gthconsult.com/img/logogth.345bbd30.png",
            "email": "contact@gthconsult.ma",
            "telephone": "+212523272774",
            "sameAs": [
              "https://www.linkedin.com/company/gthconsult/"
            ]
          },
          {
            "@type": "LocalBusiness",
            "@id": "https://gthconsult.com/#localbusiness",
            "name": "GTHCONSULT",
            "url": "https://gthconsult.com",
            "image": "https://gthconsult.com/img/logogth.345bbd30.png",
            "telephone": "+212523272774",
            "email": "contact@gthconsult.ma",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Boulevard Mohammed VI, Lot Al Massira, N 187, Appt 5-6, 3eme etage",
              "addressLocality": "Mohammedia",
              "postalCode": "28810",
              "addressCountry": "MA"
            },
            "areaServed": ["MA", "Maroc"],
            "priceRange": "$$"
          },
          {
            "@type": "WebSite",
            "@id": "https://gthconsult.com/#website",
            "url": "https://gthconsult.com",
            "name": "GTHCONSULT",
            "publisher": { "@id": "https://gthconsult.com/#organization" }
          }
        ]
      };

      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    },
  },
};
</script>

<style>
.site-main {
  min-height: 100vh;
}

.site-main.with-header {
  padding-top: 123px;
}

.whatsapp-float {
  position: fixed;
  right: 18px;
  bottom: 24px;
  z-index: 1250;
  display: inline-flex;
  align-items: center;
  gap: 11px;
  min-height: 52px;
  padding: 0 20px 0 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, #22c55e, #128c7e);
  color: #fff;
  font-weight: 900;
  text-decoration: none;
  box-shadow: 0 18px 38px rgba(18, 140, 126, 0.34);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.whatsapp-float:hover {
  transform: translateY(-2px);
  box-shadow: 0 22px 44px rgba(18, 140, 126, 0.42);
}

.whatsapp-icon {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
}

.whatsapp-icon svg {
  width: 25px;
  height: 25px;
  fill: currentColor;
}

.footer_info {
  width: 100%;
  margin-top: 56px;
  background: #fff;
  border-top: 1px solid var(--border-soft);
}

.footer_top {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  width: min(100% - 48px, 1240px);
  margin: 0 auto;
  padding: 52px 0 36px;
}

.footer_card {
  min-width: 0;
  background: #fff;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 24px;
  box-shadow: var(--shadow-card);
}

.footer_title {
  margin: 0 0 14px;
  font-size: 20px;
  font-weight: 800;
  color: var(--brand-primary);
}

.footer_card p,
.footer_contact li {
  color: var(--text-soft);
  line-height: 1.7;
  font-size: 15px;
}

.footer_contact {
  padding: 0;
  margin: 0;
}

.footer_contact li {
  list-style: none;
  margin-bottom: 10px;
  overflow-wrap: anywhere;
}

.newsletter_input {
  display: flex;
  gap: 10px;
  margin-top: 14px;
}

.newsletter_input input {
  flex: 1;
  min-width: 0;
  min-height: 46px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid var(--border-soft);
}

.newsletter_input button {
  min-height: 46px;
  padding: 0 18px;
  border: none;
  background: var(--brand-primary);
  color: #fff;
  font-weight: 800;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
}

.footer_map {
  width: min(100% - 48px, 1240px);
  height: 340px;
  margin: 0 auto 42px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

.footer_map iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.footer_bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  background: #19264f;
  color: #fff;
  padding: 22px min(6vw, 72px);
}

.footer_bottom img {
  height: 52px;
}

.footer_links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.footer_links button,
.footer_social a {
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.86);
  cursor: pointer;
  font: inherit;
  text-decoration: none;
}

.footer_social a {
  display: inline-flex;
  align-items: center;
  gap: 9px;
}

.linkedin-icon {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background: #0a66c2;
  color: #fff;
  font-weight: 900;
  font-family: Arial, Helvetica, sans-serif;
}

.footer_copyright {
  flex: 1 0 100%;
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  text-align: center;
}

.msg_subscriber {
  color: var(--brand-accent);
  min-height: 22px;
}

@media (max-width: 980px) {
  .site-main.with-header {
    padding-top: 64px;
  }

  .footer_top {
    grid-template-columns: 1fr;
    width: calc(100% - 28px);
    padding: 34px 0 28px;
  }

  .newsletter_input {
    flex-direction: column;
  }

  .footer_map {
    width: calc(100% - 28px);
    height: 280px;
    margin-bottom: 30px;
  }

  .footer_bottom {
    flex-direction: column;
    text-align: center;
    padding: 24px 16px;
  }

  .whatsapp-float {
    right: 12px;
    bottom: 96px;
    min-height: 44px;
    padding: 0 14px;
    font-size: 14px;
  }
}
</style>
